function initSmgFlipCard(card) {
  if (card.dataset.smgFlipCardBound) return;
  card.dataset.smgFlipCardBound = 'true';

  var front = card.querySelector('.smg-flip-cards__face--front');
  var back = card.querySelector('.smg-flip-cards__face--back');

  card.addEventListener('click', function () {
    var isFlipped = card.classList.toggle('is-flipped');
    card.setAttribute('aria-pressed', isFlipped ? 'true' : 'false');
    if (front) front.setAttribute('aria-hidden', isFlipped ? 'true' : 'false');
    if (back) back.setAttribute('aria-hidden', isFlipped ? 'false' : 'true');
  });
}

function initAllSmgFlipCards(scope) {
  var cards = (scope || document).querySelectorAll('[data-smg-flip-card]');
  cards.forEach(function (card) {
    initSmgFlipCard(card);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    initAllSmgFlipCards(document);
  });
} else {
  initAllSmgFlipCards(document);
}

document.addEventListener('shopify:section:load', function (e) {
  initAllSmgFlipCards(e.target);
});
